import { trackCustomEvent } from "gatsby-plugin-google-analytics"

const trackCustomEventTrigger = (trackingOptions) => {
  return trackCustomEvent({
    ...trackingOptions,
  })
}

export default trackCustomEventTrigger
